module.exports = require('./helpers/bundle-url').getBundleURL('9HgYJ') + "logo-dark.ba5147f0.svg";